var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c("div", { staticClass: "searchBox_top" }, [
        _c(
          "div",
          [
            _vm.fpaLtoSignOff
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.attachmentUpload },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("fpaManage.permanent.signatureUpload"))
                    ),
                  ]
                )
              : _vm._e(),
            _vm.fpaLtoSubmit
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.fpaLtoApprove("toNfcApprove")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.submit")))]
                )
              : _vm._e(),
            _vm.canDownload
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.attachmentDownload },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("fpaManage.permanent.attachmentDownload"))
                    ),
                  ]
                )
              : _vm._e(),
            _vm.canApprove
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.fpaLtoApprove("approving")
                      },
                    },
                  },
                  [_vm._v("Approve")]
                )
              : _vm._e(),
            _vm.canApprove
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.fpaLtoApprove("reject")
                      },
                    },
                  },
                  [_vm._v("Reject")]
                )
              : _vm._e(),
            _vm.isMdm
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.fpaPdfDownload },
                  },
                  [_vm._v(_vm._s(_vm.$t("fpaManage.permanent.pdfDownload")))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "formData",
          attrs: {
            model: _vm.formData,
            "label-width": "230px",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "view_content" }, [
            _c("div", { staticClass: "fpaNo" }, [
              _c("p", [_vm._v("FPA NO:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.serialNo))]),
            ]),
            _c("div", { staticClass: "status" }, [
              _c("p", [_vm._v("Status:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.status))]),
            ]),
            _c("div", { staticClass: "creator" }, [
              _c("p", [_vm._v("Creator:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.createUser))]),
            ]),
            _c("div", { staticClass: "createDate" }, [
              _c("p", [_vm._v("Creation Date:")]),
              _c("p", [_vm._v(_vm._s(_vm.formData.createDate))]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "info_box" },
            [
              _c("div", { staticClass: "info_box_title" }, [
                _c("p", { staticClass: "line" }),
                _c("p", { staticClass: "info_title" }, [
                  _vm._v("Basic Information"),
                ]),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 13 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "purposeOfTheAgreement" },
                        },
                        [
                          _c("p", { attrs: { slot: "label" }, slot: "label" }, [
                            _c("span", {
                              staticClass: "icon-fenlei element_icon",
                            }),
                            _vm._v(" Purpose of the Agreement "),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.formData.agreementPurpose,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "agreementPurpose",
                                    $$v
                                  )
                                },
                                expression: "formData.agreementPurpose",
                              },
                            },
                            _vm._l(
                              _vm.agreementPurposeList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm._f("inputChoiceI18n")(item),
                                    value: item.code,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 13 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "supplierName" },
                        },
                        [
                          _c("p", { attrs: { slot: "label" }, slot: "label" }, [
                            _c("span", {
                              staticClass: "el-icon-user-solid element_icon",
                            }),
                            _vm._v(" Supplier Group "),
                          ]),
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: "",
                              title: _vm.formData.supplierName,
                            },
                            model: {
                              value: _vm.formData.supplierName,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "supplierName", $$v)
                              },
                              expression: "formData.supplierName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "agreementStartDate" },
                        },
                        [
                          _c("p", { attrs: { slot: "label" }, slot: "label" }, [
                            _c("span", {
                              staticClass: "el-icon-date element_icon",
                            }),
                            _vm._v(" Campaign Start Date "),
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              placeholder: "选择日期",
                              "value-format": "yyyy-MM-dd",
                              disabled: "",
                            },
                            model: {
                              value: _vm.formData.agreementStartDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "agreementStartDate",
                                  $$v
                                )
                              },
                              expression: "formData.agreementStartDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: "Campaign End Date",
                            "label-width": "140px",
                            prop: "agreementEndDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              placeholder: "选择日期",
                              "value-format": "yyyy-MM-dd",
                              disabled: "",
                            },
                            model: {
                              value: _vm.formData.agreementEndDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "agreementEndDate", $$v)
                              },
                              expression: "formData.agreementEndDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 13 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "productOrCommodityPurchased" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "required_p",
                              attrs: { slot: "label" },
                              slot: "label",
                            },
                            [
                              _c("span", {
                                staticClass: "icon-miaoshu element_icon",
                              }),
                              _vm._v(" Product or Commodity Purchased "),
                            ]
                          ),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.formData.productOrCommodityPurchased,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "productOrCommodityPurchased",
                                  $$v
                                )
                              },
                              expression:
                                "formData.productOrCommodityPurchased",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "tab_box" },
        [
          _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "PQCP", name: "fpaPqcpTab" } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "fpaLtoPqcnList1",
                      attrs: {
                        data: _vm.formData.fpaLtoPqcnList,
                        "max-height": "500",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "supplierName",
                          label: "Supplier",
                          width: "300px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "plantName",
                          label: "Facility",
                          width: "300px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "dcIdList",
                          label: "Supplied DC",
                          width: "300px",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.isLocal == "1"
                                  ? [
                                      _c("ic-select", {
                                        attrs: {
                                          disabled: "",
                                          table: "BASE",
                                          field: "DC",
                                          multiple: true,
                                          clearable: true,
                                        },
                                        model: {
                                          value: scope.row.dcIdList,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "dcIdList", $$v)
                                          },
                                          expression: "scope.row.dcIdList",
                                        },
                                      }),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "newMenuItemName",
                          label: "Menu Item",
                          width: "150px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "ingredient",
                          label: "Ingredient",
                          width: "120px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "localItem",
                          label: "Local Item#",
                          width: "100px",
                        },
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            "show-overflow-tooltip": "",
                            align: "center",
                            label: "Price per CASE(RMB EXCL. VAT)",
                            width: "250px",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "purchaseForcast",
                              label: "Price",
                              width: "150px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-input", {
                                      attrs: {
                                        value: _vm._f("thousandSeparator")(
                                          scope.row.purchaseForcast
                                        ),
                                        disabled: "",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "uom",
                              label: "Unit",
                              width: "150px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: scope.row.uom,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "uom", $$v)
                                          },
                                          expression: "scope.row.uom",
                                        },
                                      },
                                      _vm._l(
                                        _vm.uomList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm._f("inputChoiceI18n")(item),
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "vat",
                          label: "VAT",
                          width: "90px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: scope.row.vat,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "vat", $$v)
                                      },
                                      expression: "scope.row.vat",
                                    },
                                  },
                                  _vm._l(
                                    _vm.pqcnVatRateList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          value: item.code,
                                          label:
                                            _vm._f("inputChoiceI18n")(item),
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            "show-overflow-tooltip": "",
                            align: "center",
                            label: "Price Valid Date",
                            width: "150px",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "priceValidDateFrom",
                              label: "From",
                              width: "150px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "date",
                                        placeholder: "选择日期",
                                        "value-format": "yyyy-MM-dd",
                                        disabled: "",
                                      },
                                      model: {
                                        value: scope.row.priceValidDateFrom,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "priceValidDateFrom",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.priceValidDateFrom",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "priceValidDateTo",
                              label: "to",
                              width: "150px",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        type: "date",
                                        placeholder: "选择日期",
                                        "value-format": "yyyy-MM-dd",
                                        disabled: "",
                                      },
                                      model: {
                                        value: scope.row.priceValidDateTo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "priceValidDateTo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.priceValidDateTo",
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "tradeTerm",
                          label: "Trade Term",
                          width: "250px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: scope.row.tradeTerm,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "tradeTerm", $$v)
                                      },
                                      expression: "scope.row.tradeTerm",
                                    },
                                  },
                                  _vm._l(
                                    _vm.priceTypeList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label:
                                            _vm._f("inputChoiceI18n")(item),
                                          value: item.code,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "packagingSize",
                          label: "Packing Size per CASE",
                          width: "250px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "externalPackagingNetweight",
                          label: "Net Weight (KG)",
                          width: "250px",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "transportaionMethod",
                          label: "Delivery Type",
                          width: "150px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: scope.row.transportaionMethod,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "transportaionMethod",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "scope.row.transportaionMethod",
                                    },
                                  },
                                  _vm._l(
                                    _vm.newTransportaionMethodList,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label:
                                            _vm._f("inputChoiceI18n")(item),
                                          value: item.code,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "freight",
                          label: "Freight",
                          width: "150px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("thousandSeparator")(
                                      scope.row.freight
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          prop: "totalCost",
                          label: "Total Cost(without VAT)",
                          width: "250px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("thousandSeparator")(
                                      _vm._f("fix")(scope.row.totalCost, 2)
                                    )
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          label: "Promotion Date From",
                          width: "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-date-picker", {
                                  attrs: {
                                    disabled: "",
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: scope.row.promotionDateFrom,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "promotionDateFrom",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.promotionDateFrom",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          align: "center",
                          label: "Promotion Date To",
                          width: "200",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-date-picker", {
                                  attrs: {
                                    disabled: "",
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                  },
                                  model: {
                                    value: scope.row.promotionDateTo,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        scope.row,
                                        "promotionDateTo",
                                        $$v
                                      )
                                    },
                                    expression: "scope.row.promotionDateTo",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.ttFpaLtoId > 0
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "Audit Record", name: "fpaLog" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticClass: "table",
                          attrs: {
                            data: _vm.formData.auditLogList,
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "operatorName",
                              align: "center",
                              label: "Update by",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "createDate",
                              align: "center",
                              label: "Update Time",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dateFormatFilter")(
                                              scope.row.createDate,
                                              "YYYY-MM-DD HH:mm:ss"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2863962607
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "action",
                              align: "center",
                              label: "Update Log",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              prop: "comments",
                              align: "center",
                              label: "Suggestion",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              "show-overflow-tooltip": "",
                              sortable: "",
                              align: "center",
                              label: "Attachment",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFormatFilter")(
                                            scope.row.effectiveBeginDate,
                                            "YYYY-MM-DD HH:mm"
                                          )
                                        ) + " "
                                      ),
                                      _c("fileList", {
                                        attrs: { files: scope.row.docs },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2113543
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showFileUpload,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showFileUpload = $event
            },
          },
        },
        [
          _c("FileUpload", {
            ref: "fileUploadRef",
            attrs: {
              multiple: false,
              "max-length": _vm.fileListMaxLength,
              recType: _vm.bizType,
              bizId: _vm.formData.ttFpaLtoId,
              attachmentAccept: _vm.attachmentAccept,
              seq: 0,
              showFileList: false,
              disabled: _vm.fileUploadDisabled,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "fpa",
          attrs: {
            visible: _vm.showAuditPage,
            "append-to-body": "",
            width: "25%",
            title: _vm.dialogTitle,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAuditPage = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "formData", attrs: { model: _vm.formData } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20, offset: 2 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          class:
                            _vm.dialogTitle == "Reject" ? "is-required" : "",
                          staticStyle: { width: "100%" },
                          attrs: {
                            prop: "auditRemark",
                            label: _vm.$t("fpaManage.permanent.auditRemark"),
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { type: "textarea", rows: 3 },
                            model: {
                              value: _vm.formData.auditRemark,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "auditRemark", $$v)
                              },
                              expression: "formData.auditRemark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.fpaLtoApprove("confirm")
                        },
                      },
                    },
                    [_vm._v("Confirm")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showAuditPage = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }